import { motion } from "motion/react";
import { Link } from "react-router-dom";
import { Eyebrow } from "../components/Buttons";
import { Stagger } from "../components/Reveal";
import { fadeUp, EASE } from "../motion";
import { PHONE, PHONE_HREF, SERVICES, BOOKING_URL } from "../config";

const card = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
};
const hover = { whileHover: { y: -6 }, transition: { type: "spring", stiffness: 300, damping: 22 } };

export default function Services() {
  return (
    <section className="services section section--alt" id="services">
      <div className="container">
        <Stagger as="header" className="services__head">
          <motion.div variants={fadeUp}><Eyebrow>WHAT WE OFFER</Eyebrow></motion.div>
          <motion.h2 variants={fadeUp}>Our services</motion.h2>
        </Stagger>
        <Stagger className="services__grid" gap={0.08} amount={0.1}>
          {SERVICES.map((c, i) => (
            <motion.article key={c.t} className="svc" variants={card} {...hover}>
              <span className="svc__num">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="svc__t">{c.t}</h3>
              <p className="svc__d">{c.d}</p>
              <div className="svc__foot">
                <span className="svc__price">Pricing on enquiry</span>
                <a className="svc__book" href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
                  Book <span aria-hidden="true">→</span>
                </a>
              </div>
            </motion.article>
          ))}
          <motion.article className="svc svc--blue" variants={card} {...hover}>
            <h3 className="svc__t">Full menu</h3>
            <p className="svc__d">Call us or visit in salon for our complete list and pricing.</p>
            <div className="svc__links">
              <a href={PHONE_HREF} className="svc__link">Call {PHONE} →</a>
              <Link to="/booking" className="svc__link">Book online →</Link>
            </div>
          </motion.article>
        </Stagger>
      </div>
    </section>
  );
}
